const $ = require("jquery");
const toaster = require("react-toastify");

export const onInitialClientRender = () => {

  if (window.klaro) {
    const klaroCookieName = "klaro";
    const klaroCookieExists = document.cookie
      .split("; ")
      .some((cookie) => cookie.startsWith(`${klaroCookieName}=`));

    if (!klaroCookieExists) {
      window.klaro.show();
    }
  }

  $(document).ready(function () {
    $(".menu-btn").click(function () {
      $("body").toggleClass("main");
    });
  });

  function getRandomArbitrary(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  }

  function testBlog(lang) {
    let msg;
    switch (lang) {
      case "en":
        msg = "Sorry, our blog is not available in English, yet.";
        break;
      case "es":
        msg =
          "Lo sentemos, nuestro blog no esta disponible en español, de momento";
        break;
      default:
        msg = "Unkown error";
        break;
    }
    toaster.toast.error(msg);
  }

  function frenchServiceOnly(lang) {
    let msg;
    switch (lang) {
      case "en":
        msg = "Sorry, this service is only available in French, yet.";
        break;
      case "es":
        msg =
          "Lo sentemos, este servicio sólo esta disponible en francés, de momento";
        break;
      default:
        msg = "Unknown error";
        break;
    }
    toaster.toast.error(msg);
  }

  // Adds the functions to the window object to make it available through navigation
  window.testBlog = testBlog;
  window.frenchServiceOnly = frenchServiceOnly;
};

export function shouldUpdateScroll(prevRouterProps, { location }) {
  if (prevRouterProps.routerProps.location.hash.length === 0) {
    window.scrollTo(0, 0);
    const body = document.getElementsByTagName("body")[0];
    body.scrollTop = 0;
    return false;
  } else {
    return true;
  }
}
